import { B_ITEM, C_ITEM, PL_ITEM } from '../boilerplate/item-names';

const returnItemName = ({ names, language }) => {
  switch (language.toLowerCase().trim()) {
    case 'de':
      return names[0];
    case 'fr':
      return names[1];
    case 'it':
      return names[2];
    default:
      return 'Product';
  }
};

/**
 * This util defines a proper item name depending on the language and current flow.
 * @param {string} type Type of current flow (C, PL or B)
 * @param {string} language Language of the app
 * @returns {string} Product name in proper language
 */
const getItemName = (type, language) => {
  switch (type) {
    case C_ITEM:
      return returnItemName({
        language,
        names: ['Hausratversicherung', 'Assurance-ménage', 'Assicurazione di mobilia domestica'],
      });
    case PL_ITEM:
      return returnItemName({
        language,
        names: [
          'Privathaftpflichtversicherung',
          'Responsabilité civile privée',
          'Responsabilità civile privata',
        ],
      });
    case B_ITEM:
      return returnItemName({
        language,
        names: ['Gebäudeversicherung', 'Assurance bâtiment', 'Assicurazione stabili'],
      });
    default:
      return 'Product';
  }
};

export default getItemName;
